angular.module('app').config(function (schedulerStateConfigurationProvider, schedulerCalendarConfigurationProvider) {
  schedulerCalendarConfigurationProvider.configure({
    enableCalendar: true
  });
  schedulerStateConfigurationProvider.state();
});
